<template>
  <div class="Highlights">
    <div class="Highlights__close" @click="setHighlights(false)">
    </div>
    <div class="Highlights__title">How much time do you have?</div>
    <div class="Highlights__time">{{ sliderValue }} minutes</div>
    <div class="sliderContainer">
      <vue-slider
        v-model="sliderValue"
        width="100%"
        :data="minutes"
        tooltip="false"
      ></vue-slider>
    </div>
    <div class="Highlights__button">
      <button @click="$emit('playVideo', getVideoIndex(sliderValue))">Watch Now</button>
    </div>
  </div>
</template>
<script>
  import vueSlider from 'vue-slider-component';
  import { mapState, mapMutations } from 'vuex';
  import _ from 'lodash';

  export default {
    data() {
      return {
        sliderValue: 0,
      };
    },
    mounted() {
      this.sliderValue = this.initialHighLight;
    },
    watch: {
      initialHighLight() {
        this.sliderValue = this.initialHighLight;
      },
    },
    methods: {
      ...mapMutations(['setHighlights']),
      getVideoIndex(index) {
        return _.find(this.playlist.highlights, { duration: index }).url;
      },
    },
    computed: {
      ...mapState(['highlights', 'initialHighLight', 'playlist']),
      minutes() {
        const minutes = [];
        _.forIn(this.playlist.highlights, (h) => {
          minutes.push(h.duration);
        });
        return minutes;
      },
    },
    components: {
      vueSlider,
    },
  };
</script>
<style lang="scss">
  .sliderContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .slider {
    width: 100%;
  }

  .Highlights {
    padding: 30px;
    width: 100%;
    position: relative;
    @media (min-width: 768px) {
      position: absolute;
      width: 80%;
      top: 80px;
      margin: 0 10%;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, .6);
    }
    &__title {
      text-align: center;
      color: #00acff;
    }
    &__time {
      text-align: center;
      color: white;
    }
    &__close {
      cursor: pointer;
      position: absolute;
      top: 10px;
      left: 10px;
      background-image: url(../assets/img/ic_close.png);
      width: 20px;
      height: 20px;
      background-size: cover;
    }
    &__button {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        color: white;
        background-color: #00acff;
        padding: 10px 30px;
        border-radius: 100px;
        border-width: 0;
        cursor: pointer;
      }
    }
  }

  .range-slider-fill {
    color: #00acff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Highlights.vue